// src/redux/slices/footerEditModeSlice.ts
import { createSlice } from '@reduxjs/toolkit';

interface FooterEditModeState {
  isFooterEditMode: boolean;
}

const initialState: FooterEditModeState = {
  isFooterEditMode: false,
};

export const footerEditModeSlice = createSlice({
  name: 'footerEditMode',
  initialState,
  reducers: {
    toggleFooterEditMode: (state) => {
      state.isFooterEditMode = !state.isFooterEditMode;
    },
  },
});

export const {
  toggleFooterEditMode,
} = footerEditModeSlice.actions;

export default footerEditModeSlice.reducer;
